export const firebaseConfig = {
    apiKey: "AIzaSyCYZITY896y1KRSv85i9di_kceXJdigU8I",
    authDomain: "longcode-897ac.firebaseapp.com",
    databaseURL: "https://longcode-897ac.firebaseio.com",
    projectId: "longcode-897ac",
    storageBucket: "longcode-897ac.appspot.com",
    messagingSenderId: "500573545226"
};


// WEBPACK FOOTER //
// ./config/firebase-config.js